import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const MenuItem = ({
  image,
  activeImage,
  price,
  name,
  onClick,
  isActive,
  isDisabled,
  isSecondLevel,
  macroQuantity,
  microQuantity,
  onRemove,
  removeDisabled,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`ken-configurator__accessories-menu-item${
        isActive ? ' -active' : ''
      }${isDisabled ? ' -disabled' : ''}`}
      role='button'
      tabIndex={0}
      onClick={isDisabled ? null : onClick}
      onKeyDown={e => {
        if (!isDisabled && e.key === 'Enter') {
          onClick();
        }
      }}
    >
      <div className='ken-configurator__accessories-menu-item-active-bar' />
      <div className='ken-configurator__accessories-menu-item-img-wrapper'>
        <img
          src={isActive ? activeImage || image : image}
          alt={name}
          className='ken-configurator__accessories-menu-item-img'
        />

        {microQuantity > 0 && (
          <span className='ken-configurator__accessories-menu-item-micro-quantity'>
            {microQuantity}
          </span>
        )}
      </div>
      <div className='ken-configurator__accessories-menu-item-info'>
        <span
          className={`ken-configurator__accessories-menu-item-label ${
            isActive ? '-active' : ''
          } clamp-text`}
        >
          {name}
          {macroQuantity > 0 && (
            <span className='ken-configurator__accessories-menu-item-macro-quantity'>
              {macroQuantity}
            </span>
          )}
        </span>
        <div className='ken-configurator__accessories-menu-accessory-info-price'>
          <span>{price}</span>
        </div>
      </div>

      {microQuantity > 0 && (
        <button
          type='button'
          className='ken-configurator__accessories-menu-link-btn ken-configurator__accessories-menu-product-remove'
          onClick={e => {
            e.stopPropagation();
            onRemove();
          }}
          disabled={removeDisabled}
        >
          {t('configurator:configurator.menu.remove')}
        </button>
      )}
      <img
        src={`${DLG.config.distResourcePath}/assets/images/kenwood/configurator/menu/chevron.svg`}
        alt={t('configurator:configurator.alt.toggle')}
        className={`ken-configurator__accessories-menu-item-chevron 
        ${isSecondLevel ? '-second-level' : ''}
        ${microQuantity > 0 ? '-has-quantity' : ''}
        `}
      />
    </div>
  );
};

MenuItem.propTypes = {
  image: PropTypes.string.isRequired,
  activeImage: PropTypes.string,
  price: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
  isSecondLevel: PropTypes.bool,
  macroQuantity: PropTypes.number,
  microQuantity: PropTypes.number,
  onRemove: PropTypes.func,
  removeDisabled: PropTypes.bool,
};

MenuItem.defaultProps = {
  activeImage: '',
  isSecondLevel: false,
  isDisabled: false,
  macroQuantity: 0,
  microQuantity: 0,
  onRemove: () => {},
  removeDisabled: false,
};

export default MenuItem;
